import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import contentMan from "../../img/contentMan.svg";
import contentfolder from "../../contentImgs/folder.png";

import LoadingButton from "../../Loading/LoadingButton";
import Snackbar from "../../../Snackbar";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,Timer,AudioLines,
  FolderHeart, Forward,Earth,ListChecks,Gift,Settings,BetweenHorizontalStart,
  ImagePlay,Film,AlarmSmoke,BellElectric,CircleCheck,LayoutGrid ,CornerDownRight,BotMessageSquare,ChevronUp,ChevronDown,
  GripHorizontal,
  CopyPlus,
  Bookmark,
  Pencil,
  Trash2,
  Recycle,
  Paperclip,
  FileSliders,
  ImagePlus,
  FolderArchive,
  MonitorDot,
  CalendarDays} from 'lucide-react';
import ContentMenuCard from "./ContentMenuCard";
import ContentFolderCard from "./ContentFolderCard";
import CreateFolderPopup from "./ContentPopUp/CreateFolderPopup";
import FolderFilterCard from "./FolderFilterCard";
import AddToFolderButton from "./AddToFolderButton";
import { createNewFolder, getAllFoldersByApp, reArrangeFolders } from "../../../store/actions/CreateContent/FolderAPI/FolderAPIs";
import FolderFilterCardTwo from "./FolderFilterCardTwo";
import FolderFilterCardThree from "./FolderFilterCardTwoThree";
import AreYouSurePopUp from "./ContentPopUp/AreYouSurePopUp";
import BookmarkListPopUp from "./ContentPopUp/Folder/BookmarkList";
import CreateQuizPopUp from "./Quiz/CreateQuizPopUp";
import { addEntityToAnyEntity } from "../../../store/actions/CreateContent/FolderAPI/ChapterAPI";
import QuizSetUpOuter from "./Quiz/QuizSetUpOuter";
import { createNewMockTest, getQuizDataByQuizId } from "../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
import LessonSelectCard from "./LessonSelectCard";
import CreateLessonPopUp from "./Lesson/CreateLessonPopUp";
import HomeworkLibrary from "./Homework/HomeworkLibrary";

const CreateCourseCurriculum =({selectCoursePopUp,setProductMenuRightCard ,productMenuRightCard})=>{

     const dispatch = useDispatch();
        const [openAppDesignPopUp,setopenAppDesignPopUp]  = useState(false);
        const [ isHomework,setIsHomework]  = useState(false);
       
              const [openAppDesignPopUpInnerContent,setopenAppDesignPopUpInnerContent]  = useState("appThemes");
           const user = useSelector((state)=>state?.user?.user);
           const [FolderInputData ,setFolderInputData] =useState("")
           const [activeFilterOne, setActiveFilterOne] =useState(true);
           const [activeFilterTwo, setActiveFilterTwo] =useState(false);
           const [activeFilterThree, setActiveFilterThree] =useState(false);
           const [activeFilterFour, setActiveFilterFour] =useState(false);
           const [activeFilterASC, setActiveFilterASC] =useState(true);
           const [activeFilterDESC, setActiveFilterDESC] =useState(false);
               const [snackbarVisible, setSnackbarVisible] = useState(false);
                     const [snackbarColor, setSnackbarColor] = useState("#958FDA");
                     const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
                   
                              const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
                   const showSnackbar = () => {
                     setSnackbarVisible(true);
                   };
                  
                   const hideSnackbar = () => {
                     setSnackbarVisible(false);
                   };
             
             
                        
                        
                     
                    const [animate, setAnimate] = useState(false);
      
       const [loader , setLoader] =useState({status:true});
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }




      
       const token = useSelector((state)=>state?.course?.course?.token);
       const currentToken = useSelector((state)=>state?.user?.user?.token);
       const user_email = useSelector((state)=>state?.user?.user?.user_email
      );
      
      const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
      
      const courseData = useSelector((state)=>state?.course?.course);
      
      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
     const appId = useSelector((state)=>state?.app?.app?.ID);
           const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
               
          
           const [visibility,setVisibility] =useState("public");
           const [lessonType,setLessonType] =useState("");
           const [orderBy,setOrderBy] =useState("ASC");
           const [itemArr, setItemArr] = useState([]);
           const [itemArrFolder, setItemArrFolder] = useState([]);
           const [itemReorderArr, setItemReorderArr] = useState([]);
           const [itemId, setItemId] = useState("");
           const [deleteQuizPopUp, setDeleteQuizPopUp] = useState(false);
           const [currentQuizItem, setCurrentQuizItem] = useState(null);
        
           const [deleteFolderPopUp, setDeleteFolderPopUp] = useState(false);
           const [itemArrLoading, setItemArrLoading] = useState([{},{},{},{}]);
           const [openContentInFolder, setOpenContentInFolder] = useState("");
           const [openQuizPopUpContent, setopenQuizPopUpContent] = useState("");
           const [parentFolderItem, setParentFolderItem] = useState({});
            const [quizObject, setQuizObject] = useState({ID:""});
 const [folderItem ,setFolderItem] =useState({});
 const updateItemTitle = (ID, newTitle) => {
  const updatedItems = itemArr.map(item =>
    item?.ID === ID ? { ...item, Name :newTitle } : item
  
  ); 

 // console.log(updatedItems)
  setItemArr(updatedItems);
};
const sendBackFolder = (folder) => {
  const updatedItems = [...itemArr, folder]
  const updatedItemsMenuorder = [...itemReorderArr, {ID:folder?.ID,menuOrder:folder?.menuOrder}]
  setItemReorderArr( updatedItemsMenuorder);
 // console.log(updatedItems)
  setItemArr(updatedItems);
};

      useEffect((e)=>{
        setProductMenuRightCard(true);
    fireGetAllCoursesByApp()
      
        },[visibility,orderBy,postIdCourse]);
        const fireGetAllCoursesByApp=()=>{
          setItemArr([])
                
        
                
          if(visibility=='public'){setActiveFilterTwo(true)}
          // if(openAppDesignPopUp){setActiveFilterTwo(true);setVisibility('public');}
          
        
          setItemArrLoading([{},{},{},{}])
        // Popup When Course is not selected
          if(courseData){}else{selectCoursePopUp(true);}
        
        setLoader({status:true});
            console.log({
                token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
                appToken:AppToken,visibility:visibility,orderBy:orderBy,appId:appId
                });
              const apiData = dispatch(getAllFoldersByApp({
                token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
                appToken:AppToken,visibility:visibility,orderBy:orderBy,appId:appId
                }));
              /* get response as Promise   */
              apiData.then(response => {
                console.log(response)
        
                if(response){
                 
                  if(response){
                setResponseMessage(response?.message);
                setSnackbarColor("rgba(144, 202, 249,1)");
              
                if(response?.folders) 
                   {setItemArr(response?.folders); 
         fireGetAllContentsByFolderId(response?.folders[0]);
                  const reorderArray = response?.folders.map(item => ({
                    ID: item.ID,
                    menuOrder: item.menuOrder
                }));
                setItemReorderArr(reorderArray);
                //  console.log(reorderArray)
                
                }else{setItemArr([]);};
                setItemArrLoading([]);
            setLoader({status:false});
            
            // setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
            },1000)
               }else{
            //     setResponseMessage("Something Went Wrong...");
                  
            //     setSnackbarColor("#958FDA");
            //   //  selectCoursePopUp(true);
                
                 
            // setLoader({status:false});
            // setItemArrLoading([{},{},{},{}]);
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
               }
                  
                // dispatch({
                //   type: "UPDATE_APP_TOKEN",
                  
                //   payload:response?.course?.AppToken
                // });  
              //  console.log(response?.course);
             
               // 
               if(response?.logout){
                // pop up response?.logoutInfo
                //console.log(response?.logoutInfo)
            
                setResponseMessage("You are Logged Out!!!");
                  
                setSnackbarColor("#958FDA");
               selectCoursePopUp(true);
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                setTimeout(()=>{
                  dispatch({type:"LOGOUT"});
            
                },3000)
                
              }
            /* resetting Login input Fields */
            
                }else{
                  setResponseMessage("Something Went Wrong...");
                  
                  setSnackbarColor("#958FDA");
                 selectCoursePopUp(true);
                 setItemArrLoading([{},{},{},{}]);
                   
              setLoader({status:false});
              
              setSnackbarVisible(true);
              setTimeout(()=>{
                
                setSnackbarVisible(false);
               
                 
              },3000)    }
            
              }).catch(error => {
             
                //popup of error Info
                setResponseMessage("Something Went Wrong...");
                  
                setSnackbarColor("#958FDA");
               selectCoursePopUp(true);
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                console.error(error);
              });
         }

           const fireGetAllContentsByFolderId=(folderItem)=>{
                   setItemArrFolder([])
                  
                 
                 
                 setLoader({status:true});
                     
                       const apiData = dispatch(addEntityToAnyEntity({
                         token:AppToken,courseId:postIdCourse ,parentEntityType:"Folder",parentEntityId:folderItem?.ID,postParent:folderItem?.ID,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
                         appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,visibility:visibility,orderBy:orderBy,editType:"getAllContents",
                         }));
                       /* get response as Promise   */
                       apiData.then(response => {
                        //  console.log(response)
                 
                         if(response){
                          
                           if(response){
                         setResponseMessage(response?.message);
                         setSnackbarColor("rgba(144, 202, 249,1)");
                       
                         if(response)  {setItemArrFolder(response?.contents);
                           
                        
                         }else{};
                    
                        }else{
                     
                     setSnackbarVisible(true);
                     setTimeout(()=>{
                       
                       setSnackbarVisible(false);
                      
                        
                     },3000)
                        }
                           
                        
                        if(response?.logout){
                        
                         setResponseMessage("You are Logged Out!!!");
                           
                         setSnackbarColor("#958FDA");
                       
                     setLoader({status:false});
                     
                     setTimeout(()=>{
                       
                       setSnackbarVisible(false);
                      
                        
                     },3000)
                         setTimeout(()=>{
                           dispatch({type:"LOGOUT"});
                     
                         },3000)
                         
                       }
                     /* resetting Login input Fields */
                     
                         }else{
                           setResponseMessage("Something Went Wrong...");
                           
                           setSnackbarColor("#958FDA");
                            
                       setLoader({status:false});
                       
                       setSnackbarVisible(true);
                       setTimeout(()=>{
                         
                         setSnackbarVisible(false);
                        
                          
                       },3000)    }
                     
                       }).catch(error => {
                      
                         //popup of error Info
                         setResponseMessage("Something Went Wrong...");
                           
                         setSnackbarColor("#958FDA");
                     setLoader({status:false});
                     
                     setSnackbarVisible(true);
                     setTimeout(()=>{
                       
                       setSnackbarVisible(false);
                      
                        
                     },3000)
                         console.error(error);
                       });
                  }
 const fireGetQuizDataByQuizId=(quizObjectID)=>{
   
    setLoader({status:true});
    
      const apiData = dispatch(getQuizDataByQuizId({testName:"",type:"mock",
        postParent:"",userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:"",postId:quizObjectID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
        ));
      /* get response as Promise   */
      apiData.then(response => {
        if(response){  
          if(response?.quiz){
            
        setResponseMessage(response?.message);
        setSnackbarColor("rgba(144, 202, 249,1)");
      setQuizObject(response?.quiz)
    
    
  
       }else{
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
       }
          
       
       if(response?.logout){
       
        setResponseMessage("You are Logged Out!!!");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        setTimeout(()=>{
          dispatch({type:"LOGOUT"});
    
        },3000)
        
      }
    /* resetting Login input Fields */
    
        }else{
          setResponseMessage("Something Went Wrong...");
          
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)    }
    
      }).catch(error => {
     
        //popup of error Info
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        console.error(error);
      });
     
      }
        const handleDeleteMockTest=(item)=>{
           
           
           
           setLoader({status:true});
           
             const apiData = dispatch(createNewMockTest({userEmail:user_email?user_email:"",
               currentToken:currentToken?currentToken:"",
               editType:"deleteQuiz",postId:item?.contentID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}));
             /* get response as Promise   */
             apiData.then(response => {
               if(response){  
                
              
              if(response?.logout){
              
               setResponseMessage("You are Logged Out!!!");
                 
               setSnackbarColor("#958FDA");
            
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
              
           },3000)
               setTimeout(()=>{
                 dispatch({type:"LOGOUT"});
           
               },3000)
               
             }
           /* resetting Login input Fields */
           
               }else{
                 setResponseMessage("Something Went Wrong...");
                 
                 setSnackbarColor("#958FDA");
              
                  
             setLoader({status:false});
             
             setSnackbarVisible(true);
             setTimeout(()=>{
               
               setSnackbarVisible(false);
              
                
             },3000)    }
           
             }).catch(error => {
            
               //popup of error Info
               setResponseMessage("Something Went Wrong...");
                 
               setSnackbarColor("#958FDA");
            
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
              
           },3000)
               console.error(error);
             });
            
             }
const handleReArrangeFolder =(reorderedItemsArray)=>{
// console.log({
//   token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
//   appToken:AppToken,menuOrder:itemReorderArr,orderBy:orderBy
//   })


  const apiData = dispatch(reArrangeFolders({
    token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
    appToken:AppToken,menuOrder:JSON.stringify(reorderedItemsArray),orderBy:orderBy,appId:appId
    }));
  /* get response as Promise   */
  apiData.then(response => {
    // console.log(response)

 
     
      if(response){
        
  // setSnackbarVisible(true);
    setResponseMessage("Saved Successfully!!!");
    setSnackbarColor("rgba(144, 202, 249,1)");
  
   
setLoader({status:false});

setTimeout(()=>{
  
  setSnackbarVisible(false);
},1000)
   }else{

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
   }
      
    
   if(response?.logout){
    // pop up response?.logoutInfo
    //console.log(response?.logoutInfo)

    setResponseMessage("You are Logged Out!!!");
      
    setSnackbarColor("#958FDA");
   selectCoursePopUp(true);
    
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    setTimeout(()=>{
      dispatch({type:"LOGOUT"});

    },3000)
    
  }


   

  }).catch(error => {
 
    //popup of error Info
    setResponseMessage("Something Went Wrong...");
      
    setSnackbarColor("#958FDA");
    
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    console.error(error);
  });
}



const handleDeleteFolder=(val,folderID)=>{
  let editType=val;

  setLoader({status:true});

        const apiData = dispatch(createNewFolder({
      token:token,courseId:postIdCourse ,postParent:postIdCourse ,userEmail:user_email?user_email:null,
      currentToken:currentToken?currentToken:null,appToken:AppToken,
      editType:editType,postId:folderID,menuOrder:1,appId:appId}));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){

        // console.log(response)
        if(response?.folder){
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
   if(val=="deleteFolder"){
    // setActiveFilterTwo(false);;setActiveFilterThree(true);
    const removedItems = itemArr.filter(item => item?.ID !== response?.folder?.ID);
    setItemArr(removedItems);
   } 
    if(val=="restoreFolder"){
      // setActiveFilterTwo(true);;setActiveFilterThree(false);
      const removedItems = itemArr.filter(item => item?.ID !== response?.folder?.ID);
    setItemArr(removedItems);
    }

  },1000)
     }else{
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
     
     if(response?.logout){
     
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }

        const flattenedData = itemArr!=[]?Object.values(itemArr):'';
 const flattenedDataFolder = itemArrFolder!=[]?Object.values(itemArrFolder):'';

        const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';


        const [reorderFolderPopUp, setReorderFolderPopUp] =useState(false);
        const [bookmarkListPopUp, setBookmarkListPopUp] =useState(false);
        
const [draggedIndex, setDraggedIndex] = useState('');
const [hoveredDropZone, setHoveredDropZone] = useState(null); // Track hovered drop zone
const [selectedItemIndex, setSelectedItemIndex] = useState(null); // Track hovered drop zone

const handleDragStart = (e, index) => {
  
  e.dataTransfer.effectAllowed = 'move';
  e.dataTransfer.setData("dragIndex", index);
  
};

const handleDrop = (e, dropIndex) => {
  const dragIndex = e.dataTransfer.getData("dragIndex");
  if (dragIndex === dropIndex) return;

  const updatedItems = [...itemArr];
  const [draggedItem] = updatedItems.splice(dragIndex, 1);
  updatedItems.splice(dropIndex, 0, draggedItem);

  const reorderedItems = updatedItems.map((item, index) => ({
    ...item,
    ID: item.ID,
    menuOrder:index+1
  }));
  const updatedItemsReorder = [...itemReorderArr];
  const [draggedItemReorder] = updatedItemsReorder.splice(dragIndex, 1);
  updatedItemsReorder.splice(dropIndex, 0, draggedItemReorder);


  setItemArr(reorderedItems);

  const reorderedItemsReorder = updatedItemsReorder.map((item, index) => ({
    ...item,
    ID: item.ID,
    menuOrder:index+1
  }));


// console.log(reorderedItemsReorder)
  setItemReorderArr(reorderedItemsReorder);
  
  setTimeout(()=>{handleReArrangeFolder(reorderedItemsReorder);},1000)
  // setTimeout(()=>{setReorderFolderPopUp(true);},1000)
  // pop up For Saving This Order . Send Array Json To Backend
  // console.log(itemReorderArr)
  setDraggedIndex('');
  setHoveredDropZone(null); // Reset hovered drop zone
};

const handleDragOver = (e, index) => {
  e.preventDefault();
   // Set the hovered drop zone
};

const handleDragEnd = () => {
  setDraggedIndex('');
  setHoveredDropZone(null); // Clear hovered drop zone
};
   

    return (<>
    {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}
        <div  align="left" className="gridForContentFoldersOuter " style={{background:"#ffffff",borderRadius:"25px",overflow:"hidden",margin:"0px",padding:"0px",left:"1%",right:"1%",}}> 
        <div className="contentPageScroller" style={{borderRadius:"25px",margin:"0px",}} >
          <div className="gridForFolderFilter">
            <FolderFilterCardTwo   activeCard={!isHomework?true:false}  icon={6} title ="Contents" onClickPopup={()=>{
   setIsHomework(false)
} }  /> 
<FolderFilterCardTwo   activeCard={isHomework?true:false}   icon={6} title ="Homework" onClickPopup={()=>{
    setIsHomework(true)
} }  /> 


 
</div>
          {isHomework?<HomeworkLibrary setQuizObject={(v)=>{setQuizObject(v)}}  />:<div className="themeNone"  style={{margin:"0px",marginTop:"5px",overflow:"hidden",
  minHeight:"190px",border:"0px dashed rgba(144, 202, 249,1)",position:"relative"}}>
{/* <div style={{position:"absolute",right:"15px",top:"0px",borderTopLeftRadius:"5px",
  borderBottomLeftRadius:"50px",background:"#EBF6FF"}}>
<img     src={contentMan} 
        alt="selected Img"
   style={{cursor:"pointer",width:"100px"
    
   }}/>
</div> */}
<div className=" ">  <div className="gridForFolderFilter">
<FolderFilterCard   activeCard={activeFilterOne}   icon={6} title ="+ New Folder" onClickPopup={()=>{
    setActiveFilterOne(true);setActiveFilterTwo(true);;setActiveFilterThree(false);setVisibility('public'); 
    setFolderItem(null);    setopenAppDesignPopUp(true);setopenAppDesignPopUpInnerContent("createFolder");
} }  /> 
<FolderFilterCardTwo   activeCard={activeFilterTwo}  icon={6} title ="Show All" onClickPopup={()=>{setVisibility('public');
  setActiveFilterTwo(true);;setActiveFilterThree(false);setActiveFilterFour(false); 
} }  />
<FolderFilterCardTwo   activeCard={activeFilterThree}  icon={6} title ="Show Deleted" onClickPopup={()=>{setVisibility('trash');
   setActiveFilterTwo(false);;setActiveFilterThree(true);setActiveFilterFour(false); 
} }  />
<FolderFilterCardThree   activeCard={activeFilterASC}  icon={6} title ="ASC" onClickPopup={()=>{
  setActiveFilterASC(true);setActiveFilterDESC(false); setOrderBy("ASC");
   
} }  /> 
<FolderFilterCardThree   activeCard={activeFilterDESC}  icon={6} title ="DESC" onClickPopup={()=>{ 
   setActiveFilterASC(false);setActiveFilterDESC(true);setOrderBy("DESC");
    
} }  /> 
{/* <FolderFilterCardTwo   activeCard={activeFilterFour}  icon={6} title ="Import" onClickPopup={()=>{} }  />  */}

 
</div>
<h3 align="center">
  
  {flattenedData?.length?"Showing "  +(flattenedData?.length):flattenedDataLoading?"Searching ":"No"}
   {activeFilterTwo?" Folders":activeFilterThree?" Deleted Folders":""} 
  
  {activeFilterTwo||activeFilterThree&&activeFilterASC?" In Ascending Order  ":activeFilterTwo||activeFilterThree?" In Descending Order  ":""}
 
  
  </h3>

{flattenedData?flattenedData?.map((item, index) => 
        (<div  index={index} key={item?.ID} 
          >{visibility=="public"&&selectedItemIndex!==index?<div
            className="drop-zone"
            onDragOver={(e) => {setHoveredDropZone(index);
              handleDragOver(e, index)
            }}
            onDrop={(e) => {handleDrop(e, index);setSelectedItemIndex(null);}}
          
            style={{
              height: hoveredDropZone === index ?'45px':"10px",position:hoveredDropZone === index ?'relative':"",left:"0px",right:"0px",
              backgroundColor: hoveredDropZone === index ? 'rgba(149, 143, 218,0.2) ' : 'transparent', // Change color on hover
              border: hoveredDropZone === index ? '2px dashed rgba(149, 143, 218,1) ' : 'transparent', // Change color on hover
              transition: 'background-color  0.3s ease',
              borderRadius: '10px',marginBottom:hoveredDropZone === index ?"10px":"0px"
             
            }}
          ></div>:""}
            <div
             draggable 
             onDragOver={(e) => { if(selectedItemIndex!==index){setHoveredDropZone(index);
                 handleDragOver(e, index)}
               }}
               onDrop={(e) => {if(selectedItemIndex!==index){handleDrop(e, index);setSelectedItemIndex(null);}}}
             
             onDragStart={(e) =>{ handleDragStart(e, index);
              setDraggedIndex(item.ID); setSelectedItemIndex(index);
             }}className={draggedIndex == item.ID?"posFixed":"posRelative"  }
             style={{
              width:"100%"
             
              
            }}  
          
              onDragEnd={handleDragEnd}
            >
<div  className="courseContentItemOuterHeadActiveSettings" style={{marginTop:"0px",paddingLeft:"10px",}}>
<div className="courseContentItemJustifyContentIcons">{visibility=="public"?<GripHorizontal  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#666666" style={{padding:"4px",background:"#ffffff",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :<div></div>}
<img     src={contentfolder} 
        alt="selected Img"
   style={{cursor:"pointer",width:"25px",height:"25px",paddingLeft:"5px"
    
   }}/> </div><div className="courseContentItemJustifyContent"> <div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
  {item?.Name}
 
      </div></div><div  className="courseContentItemOuterHeadActiveSettingsInn"
 style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
  {visibility=="public"?<div></div> :<div></div>}
{visibility=="public"?<div></div> :<div></div>}
{visibility=="public"?<Pencil onClick={()=>{setVisibility('public');setActiveFilterTwo(true);;setActiveFilterThree(false);setActiveFilterFour(false); 
setFolderItem(item); setopenAppDesignPopUp(true);setOpenContentInFolder("");setopenAppDesignPopUpInnerContent("createFolder");}}
 onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#666666" style={{padding:"4px",background:"#ffffff",borderRadius:"5px",cursor:"pointer"}}/>:<div></div> }
          
{visibility=="public"?<Trash2  onClick={()=>{ setItemId(item?.ID);setOpenContentInFolder("");setDeleteFolderPopUp('deleteFolder') ;
}}  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#666666" style={{padding:"4px",background:"#ffffff",borderRadius:"5px",cursor:"pointer"}}/> :
 <Recycle onClick={()=>{ setItemId(item?.ID);setOpenContentInFolder("");setDeleteFolderPopUp('restoreFolder') ;
 }}  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#666666" style={{padding:"4px",background:"#ffffff",borderRadius:"5px",cursor:"pointer"}}/>}
 </div>
  {visibility=="public"?openContentInFolder==item?.ID?<ChevronDown onClick={()=>{setOpenContentInFolder("");fireGetAllContentsByFolderId(item)}}  onMouseEnter={handleMouseEnter}
 onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" style={{padding:"2px",cursor:"pointer"}}/> 
:<ChevronUp onClick={()=>{setOpenContentInFolder(item?.ID);fireGetAllContentsByFolderId(item)}}  onMouseEnter={handleMouseEnter}
onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" style={{padding:"2px",cursor:"pointer"}}/> 
:""}</div>
{openContentInFolder==item?.ID?flattenedDataFolder?.length?flattenedDataFolder?.map((itemFolder, indexFolder) => 
        (<>{<div  index={indexFolder} key={itemFolder?.ID} style={{margin:"0px",marginTop:"10px",padding:"0px",paddingLeft:"0px",background:"#ffffff"}}   >
<div  className="courseContentItemOuterHeadActiveSettings" style={{margin:"10px",marginTop:"0px",padding:"10px",paddingLeft:"10px",background:" rgba(144, 202, 249,0.1)"}} >
<div className="courseContentItemJustifyContentIcons">
  { itemFolder?.postType=="Quiz"?<CalendarDays onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="rgba(144, 202, 249,1)" style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :itemFolder?.postType=="Video"?<Video onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="rgba(144, 202, 249,1)" style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :itemFolder?.postType=="Audio"?<AudioLines onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="rgba(144, 202, 249,1)" style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :itemFolder?.postType=="Pdf"?<FileSliders onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="rgba(144, 202, 249,1)" style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :itemFolder?.postType=="Image"?<ImagePlus onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="rgba(144, 202, 249,1)" style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :itemFolder?.postType=="Zip"?<FolderArchive onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="rgba(144, 202, 249,1)" style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :itemFolder?.postType=="Ppt"?<MonitorDot onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="rgba(144, 202, 249,1)" style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :<div></div>}
   
 </div><div className="courseContentItemJustifyContent"> <div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
  {itemFolder?.menuOrder}: {itemFolder?.postType} -  {itemFolder?.Name}
 
      </div></div><div  className="courseContentItemOuterHeadActiveSettingsInnTwo"
         style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
            <div></div>
{visibility=="public"?<Pencil onClick={()=>{if(itemFolder?.postType=="Quiz"){fireGetQuizDataByQuizId(itemFolder?.contentID)}}} 
   onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
    fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>:<div></div> }
    
          {visibility=="public"?<Trash2  onClick={()=>{setCurrentQuizItem(itemFolder);setDeleteQuizPopUp("deleteQuiz")}}  onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
         color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/> :
         <Recycle onClick={()=>{  }}  onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
         color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>}
         </div>
          
          
     
 </div></div>}</>)):"":""}
 



  

 {openContentInFolder==item?.ID?<div  className=""style={{display:"flex",justifyContent:"space-between",
alignContent:"center",textAlign:"center",gap:"0px",margin:"0px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}>
<AddToFolderButton title ="Add Content" onClickPopup={()=>{setopenAppDesignPopUp(true);setopenAppDesignPopUpInnerContent("createContent");;setParentFolderItem(item)}}  />
        <AddToFolderButton title ="Add Quiz"  onClickPopup={()=>{setopenQuizPopUpContent("createQuiz");setParentFolderItem(item)}} />
        <AddToFolderButton title ="Add Homework" onClickPopup={()=>{ setIsHomework(true)}}  />
      </div>:""}</div>  
  
  </div>)):""}
      {flattenedDataLoading?.map((item, index) => 
        (<div  index={index} key={index} 
          >
<div  className="chapterContentItemGridOuter" style={{margin:"10px",minHeight:"40px",marginTop:"10px",paddingLeft:"10px",background:"#ffffff"}}>
         <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div> <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
   </div><div  className="text-linetw" style={{marginTop:"5px",height:"17px",width:"94%",paddingLeft:"10px",padding:"5px"}}>
</div><div  className="courseContentItemOuterHeadActiveSettingsInn"
   style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
     <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div> <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div>  <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div><div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div></div>
     </div>  </div>)) }

  {flattenedDataLoading?.length==0?flattenedData?.length?"": <div align="center"style={{margin:"15px",padding:"10px",borderRadius:"15px",background:"rgba(255,114,94,0.1)"}}><h3 style={{"textAlign":"center",
       
      }}> Opps... <span className="coloredTextV1">No Folders Found !!!</span> {activeFilterThree?" Deleted Folders Will Show Up Here..."
        :" Create Your First Folder And Add Contents , Quizzes or Homeworks." } </h3>
      <h5>
         </h5>
      </div>:""}
      {/* <div  className="courseContentItemOuter">
      <NotepadText  strokeWidth={2} absoluteStrokeWidth  size={23}  color="#90CAF9"/> 
      <div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
   This Course Includes Hands On Exercises Videos And Tests 
 
      </div><div className="themeNone innerContentInfoStyle "
 >3 Attempts</div>
      </div>
      <div  className="courseContentItemOuter">
      <ImagePlay strokeWidth={2} absoluteStrokeWidth  size={23}  color="#90CAF9"/> 
      <div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
  This Course Includes Hands On Exercises Videos And Tests 
      </div><div className="themeNone innerContentInfoStyle"
 style={{}}>3Min 23Sec</div>
      </div>
      <div  className="courseContentItemOuter">
      <Film strokeWidth={2} absoluteStrokeWidth  size={23}  color="#90CAF9"/> 
      <div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
  This Course Will Equip You With All Inportant Trends In Blender
      </div><div className="themeNone innerContentInfoStyle"
 style={{}}>See Schedule</div>
      </div>


      <div  className="gridForFolderOptionContents">
<AddToFolderButton title ="Add Content" onClickPopup={()=>{setopenAppDesignPopUp(true);setopenAppDesignPopUpInnerContent("createContent");}}  />
        <AddToFolderButton title ="Add Quiz" onClickPopup={()=>{setopenAppDesignPopUp(true);setopenAppDesignPopUpInnerContent("createQuiz");}} />
        <AddToFolderButton title ="Add Homework" onClickPopup={()=>{setopenAppDesignPopUp(true);setopenAppDesignPopUpInnerContent("createHomework");}}  />
      </div>

      <div  className="courseContentItemOuterHeadInActive">
        <div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
   This Course Includes 
 
      </div><div className="themeNone "
 style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>25% <span className="hidexs">progress</span></div>
 <ChevronDown strokeWidth={2} absoluteStrokeWidth  size={18}  color="#555"/> 
  
      </div><div  className="courseContentItemOuterHeadInActive">
        <div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
   This Course Includes 
 
      </div><div className="themeNone "
 style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>25% <span className="hidexs">progress</span></div>
 <ChevronDown strokeWidth={2} absoluteStrokeWidth  size={18}  color="#555"/> 
      </div><div  className="courseContentItemOuterHeadInActive">
        <div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
   This Course Includes 
 
      </div><div className="themeNone "
 style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>25% <span className="hidexs">progress</span></div>  
 <ChevronDown strokeWidth={2} absoluteStrokeWidth  size={18}  color="#555"/> 
      </div> */}



</div>
<div className="contentsRemainingButtonOuter">
  <div  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{
           
    setActiveFilterOne(true);setActiveFilterTwo(true);;setActiveFilterThree(false);setVisibility('public'); 
    setFolderItem(null);    setopenAppDesignPopUp(true);setopenAppDesignPopUpInnerContent("createFolder");
            }}  className="themeNone contentsRemainingButtonOuter"  style={{fontSize:"16px",color:"#fff",
  border:"1px solid #958FDA",fontWeight:"700",cursor:"pointer",
 borderRadius:"5px",margin:"13px",textAlign:"center",height:"20px",background:"#958FDA"}}>
  <Plus  strokeWidth={3}   absoluteStrokeWidth  size={25}  color="#fff"/> <div className="themeNone"  style={{margin:"0px"}}> 
    <div  className="themeNone" style={{marginTop:"-5px"}}>  Add New Folder</div></div></div>
  </div>
  </div>  }

  </div>
        <div  className="fix-menu-theme-rightjj" style={{padding:"15px"}}><ContentFolderCard title ="Create A Folder" onClickPopup={()=>{ 
          
    setActiveFilterOne(true);setActiveFilterTwo(true);;setActiveFilterThree(false);setVisibility('public'); 
    setFolderItem(null);    setopenAppDesignPopUp(true);setopenAppDesignPopUpInnerContent("createFolder");;}}  />
     
     
     
          <ContentFolderCard title ="Create Content" onClickPopup={()=>{setopenAppDesignPopUp(true);setopenAppDesignPopUpInnerContent("createContent");setParentFolderItem({ID:""})}}  />
        <ContentFolderCard title ="Create Quiz" onClickPopup={()=>{setopenQuizPopUpContent("createQuiz");setParentFolderItem({ID:""})}} />
        <ContentFolderCard title ="Create Homework" onClickPopup={()=>{setIsHomework(true)}}  />
        {/* <ContentFolderCard title ="Import A Folder" onClickPopup={()=>{ setopenAppDesignPopUp(true);setopenAppDesignPopUpInnerContent("importFolder");}}  /> */}
         </div>
          
</div>

{bookmarkListPopUp?<BookmarkListPopUp folderItem={folderItem} loadingText="Re-Aranging..." title="Save This Arrangement" type="reorderFolder"
 closePopUp={()=>{setBookmarkListPopUp(false)}}
 />:""}
{reorderFolderPopUp?<AreYouSurePopUp loadingText="Re-Aranging..." title="Save This Arrangement" type="reorderFolder"
 closePopUp={()=>{setReorderFolderPopUp(false)}}
 onClickPopup={(type)=>{
 
  }}/>:""}

{deleteFolderPopUp=='deleteFolder'?<AreYouSurePopUp loadingText="Deleting..."  title="Delete This Folder" type="deleteFolder"
 closePopUp={()=>{setDeleteFolderPopUp(false)}}
 onClickPopup={(type)=>{handleDeleteFolder(type,itemId);setTimeout(()=>{setDeleteFolderPopUp(false)},1000)
  }}/>:deleteFolderPopUp=='restoreFolder'?<AreYouSurePopUp loadingText="Restoring..." title="Restore This Folder" type="restoreFolder" closePopUp={()=>{setDeleteFolderPopUp(false)}} 
  onClickPopup={(type)=>{handleDeleteFolder(type,itemId);setTimeout(()=>{setDeleteFolderPopUp(false)},1000)
  }}/>:""};

{deleteQuizPopUp=='deleteQuiz'?<AreYouSurePopUp loadingText="Deleting..."  title="Delete This Content" type="deleteQuiz"
 closePopUp={()=>{setDeleteQuizPopUp(false)}}
 onClickPopup={(type)=>{handleDeleteMockTest(currentQuizItem);setTimeout(()=>{setDeleteQuizPopUp(false)},1000)
  }}/>:deleteFolderPopUp=='restoreQuiz'?<AreYouSurePopUp loadingText="Restoring..." title="Restore This Content" type="restoreQuiz" closePopUp={()=>{setDeleteQuizPopUp(false)}} 
  onClickPopup={(type)=>{handleDeleteMockTest(currentQuizItem);setTimeout(()=>{setDeleteQuizPopUp(false)},1000)
  }}/>:""}

 {openAppDesignPopUp?<div className="appDesignPopUp"  style={{zIndex:99,} }>
   <div   onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} style={{cursor:"pointer",zIndex:95}} onClick={()=>{setopenAppDesignPopUp()}} 
            className="appDesignPopUpOpacity"></div>
   <div   className="appDesignPopUpInner " style={{margin:'0px',
    overflowY: "auto",zIndex:99999,background:"#f9f9f9",top:"50px"}}>
         
        <div className="userInfoLiner" style={{background:"#ffffff"}} >
        <div className="userInfoLinerInn" style={{background:"#ffffff"}}>
        
          <img  className="userInfoLinerPic"src={user?.profile_pic?user?.profile_pic:"https://img.freepik.com/free-vector/illustration-businessman_53876-5856.jpg"} alt={user?.profile_pic} />
           <div className="userInfoLinerName">
        
        
           {openAppDesignPopUpInnerContent=="createFolder"? <h2>Create  A Folder</h2> :
           openAppDesignPopUpInnerContent=="createContent"? <h2>Choose Content Type</h2>  :
         openAppDesignPopUpInnerContent=="createHomework"? <h2>Create Homework</h2>:
         openAppDesignPopUpInnerContent=="importFolder"? <h2>Import From Available Folders</h2> :
         openAppDesignPopUpInnerContent=="sidebarThemes"? <h2>Choose Dashboard Design</h2> :
          openAppDesignPopUpInnerContent=="filterThemes"? <h2>Choose Filter Design</h2> :""}
          </div>
          </div>  <div className="userInfoLinerInn">
          {/* <div   onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} style={{cursor:"pointer",}} onClick={()=>{setopenAppDesignPopUp()}}   className="userInfoLinerButton">
        Close
          </div> */}





          
          </div>
          </div>
          
        

       <div style={{height:"80vh",overflow:"auto",}}>
       
       {openAppDesignPopUpInnerContent=="createFolder"?
         <CreateFolderPopup menuOrder={flattenedData?.length} sendBackFolder={(folder)=>{sendBackFolder(folder)}} changeItemTitle={(id,title)=>{updateItemTitle(id,title)} }  folderItem={folderItem} setopenAppDesignPopUp={setopenAppDesignPopUp} /> 
         :openAppDesignPopUpInnerContent=="createContent"?
         <div className="gridForWhatsNextAfterYT2" style={{alignContent:"center",textAlign:"center",marginTop:"50px",
     
      transition: 'transform 2s ease, opacity 1s ease',
    }}>
      <LessonSelectCard icon={1}cardTitle={"+ Video"} cardValue={"video"}
    onClickBack={(val)=>{setLessonType(val);setopenQuizPopUpContent("createLesson");}} buttonTitle={"+Create New Video Lesson"} />
         <LessonSelectCard icon={2}cardTitle={"+ Audio"} cardValue={"audio"}
    onClickBack={(val)=>{setLessonType(val);setopenQuizPopUpContent("createLesson");}} buttonTitle={"+Create New Audio Lesson"} />
       <LessonSelectCard icon={3}cardTitle={"+ PDF"} cardValue={"pdf"}
    onClickBack={(val)=>{setLessonType(val);setopenQuizPopUpContent("createLesson");}} buttonTitle={"+Create New PDF Lesson"} />
       <LessonSelectCard icon={4}cardTitle={"+ Image"} cardValue={"image"}
    onClickBack={(val)=>{setLessonType(val);setopenQuizPopUpContent("createLesson");}} buttonTitle={"+Add New Image "} />
        <LessonSelectCard icon={6}cardTitle={"+ PPT"} cardValue={"ppt"}
    onClickBack={(val)=>{setLessonType(val);setopenQuizPopUpContent("createLesson");}} buttonTitle={"+Add New PPT "} />
         <LessonSelectCard icon={5}cardTitle={"+ Zip"} cardValue={"zip"}
    onClickBack={(val)=>{setLessonType(val);setopenQuizPopUpContent("createLesson");}} buttonTitle={"+Add New Zip "} />
   
      </div>  :  openAppDesignPopUpInnerContent=="createHomework"?<div className="gridForWhatsNextAfterYT2" style={{alignContent:"center",textAlign:"center",marginTop:"50px",
     
     transition: 'transform 2s ease, opacity 1s ease',
   }}>


     </div>: openAppDesignPopUpInnerContent=="importFolder"?<div className="gridForWhatsNextAfterYT" style={{alignContent:"center",textAlign:"center",marginTop:"50px",
     
     transition: 'transform 2s ease, opacity 1s ease',
   }}>
     </div>:openAppDesignPopUpInnerContent=="sidebarThemes"?<div className="gridForWhatsNextAfterYT" style={{alignContent:"center",textAlign:"center",marginTop:"50px",
     
     transition: 'transform 2s ease, opacity 1s ease',
   }}>
      </div>:openAppDesignPopUpInnerContent=="filterThemes"?<div className="gridForWhatsNextAfterYT" style={{alignContent:"center",textAlign:"center",marginTop:"50px",
     
     transition: 'transform 2s ease, opacity 1s ease',
   }}>
     </div>:"" }
      
      </div>
        
         </div></div>:""}

  {openQuizPopUpContent=="createLesson"?<CreateLessonPopUp courseId={postIdCourse} lessonType={lessonType} menuOrder={itemArrFolder?.length+1} setParentFolderItem={parentFolderItem} closeQuizPopUp={()=>{setopenQuizPopUpContent(""); fireGetAllCoursesByApp()}}/>:""}
      
        {openQuizPopUpContent=="createQuiz"?<CreateQuizPopUp menuOrder={itemArrFolder?.length+1} setParentFolderItem={parentFolderItem} closeQuizPopUp={()=>{setopenQuizPopUpContent(""); fireGetAllCoursesByApp()}}/>:""}
           {quizObject?.ID?<QuizSetUpOuter quizObject={quizObject}  setQuizObjectDataBack={(data)=>{setQuizObject(data)}} closeQuizPopUp={()=>{setQuizObject("")}}/>:""}
   
          </>)
}
export default CreateCourseCurriculum;

